import {VideoContext, VideoProvider} from "../../context/videoContext";
import Body from "../common/Body";
import React, {useContext, useEffect} from "react";
import {WidgetContext} from "../../context/widgetContext";
import HtmlParsedText from "../common/HtmlParsedText";
import {TITLE, VIDEO_DESCRIPTION, VIDEO_TITLE} from "../../config/config";
import Normal from "./tabs/Normal";
import TabbedContents from "../common/TabbedContents";
import Friends from "./tabs/Friends";
import Vip from "./tabs/Vip";
import {AuthContext} from "../../context/authContext";

const HeroContent = () => {
	return (
		<div className="px-2 pt-2 md:px-4 md:pt-4">
			<section className="flex items-center mb-2">
				<div>
					<h1 className="text-lg font-medium text-white">{VIDEO_TITLE}</h1>
					<p className="text-sm text-url">{VIDEO_DESCRIPTION}</p>
				</div>
			</section>
		</div>
	);
}

const SidenavContent = () => {
	const {
		forum_overview_members_online,
		tag_cloud,
		fetchWidgetHtml
	} = useContext(WidgetContext);

	useEffect(() => {
		fetchWidgetHtml('forum_overview_members_online');
		fetchWidgetHtml('tag_cloud');
	}, [fetchWidgetHtml]);

	return (
		<>
			{forum_overview_members_online && (
				<div className="mb-4">
					{forum_overview_members_online && <HtmlParsedText text={forum_overview_members_online}/>}
				</div>
			)}

			{tag_cloud && (
				<div className="mb-4">
					{tag_cloud && <HtmlParsedText text={tag_cloud}/>}
				</div>
			)}
		</>
	);
}

const MainContent = ({initialTab = null}) => {
	const {visitor} = useContext(AuthContext);

	const tabContents = [];
	if (visitor && visitor.can_view_videos) {
		tabContents.push({
				label: 'Videos',
				content: <Normal />
		});

		tabContents.push({
			label: 'Friends',
			content: <Friends />
		});
	}

	if (visitor && visitor.can_view_videos_vip) {
		tabContents.push({
				label: 'VIP',
				content: <Vip />
		});
	}

	let initialTabIndex = null;
	if (initialTab === 'normal') {
		initialTabIndex = 0;
	} else if (initialTab === 'friends') {
		initialTabIndex = 1;
	} else if (initialTab === 'vip') {
		initialTabIndex = 2;
	}

	useEffect(() => {
		document.title = `${VIDEO_TITLE} | ${TITLE}`;
		document.querySelector('meta[name="description"]').setAttribute("content", VIDEO_DESCRIPTION);
	});

	if (visitor && visitor.can_view_videos) {
		return (
			<div>
				<TabbedContents tabContents={tabContents} hasBorder={false} initialIndex={initialTabIndex} />
			</div>
		);
	} else {
		return (
			<div className="p-4 text-white text-xl text-center">
				Vui lòng đăng nhập để xem videos
			</div>
		);
	}
}

const VideoIndex = ({initialTab = null}) => {
	return (
		<VideoProvider>
			<Body
				heroContent={<HeroContent/>}
				mainContent={<MainContent initialTab={initialTab}/>}
				sidenavContent={<SidenavContent/>}
			/>
		</VideoProvider>
	);
}

export default VideoIndex;